import React from "react"
import styled from "styled-components"
import lightbulb from "../../../../../images/icon-lightbulb.svg"


const SpeedBumpContainer = styled.div`
  display: flex;
  border-radius: 4px;
  background-color: #CAE9FF;
  color: #0588DD;
  font-size: 14px;
  font-weight: 500;
  margin: 10px auto;
  padding: 15px;
  width: 100%;
  letter-spacing: 0;
  line-height: 18px;
`

const SpeedBumpIcon = styled.i`
  background-image: url(${lightbulb});
  background-repeat: no-repeat;
  width: 16px;
  flex-basis: 16px;
  flex-grow: 0;
  flex-shrink: 0;
`

const SpeedBumpContent = styled.div`
  padding-left: 6px;
`

const OptOutLink = styled.div`
  height: 15px;
  width: 287px;
  color: #0588DD;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 15px;
  margin-top: 7px;
  text-decoration: underline;
  cursor: pointer;
`

const recordOptOut = (localStorageKey) => localStorage.setItem(localStorageKey, "true")

const getOptOut = (localStorageKey) => localStorage.getItem(localStorageKey)

export const speedBumpOptedOut = (localStorageKey) => !!getOptOut(localStorageKey)

const SpeedBump = (props)  =>{
    const {localStorageKey, message, onOptOutClick, showOptOutLink} = props

    const onClick = () => {
      recordOptOut(localStorageKey)
      onOptOutClick()
    }

    return (
      <div>
        { !speedBumpOptedOut(localStorageKey) &&
          <SpeedBumpContainer>
            <SpeedBumpIcon/>
            <SpeedBumpContent>{message}
              {showOptOutLink && <OptOutLink onClick={onClick}> Don't show this again </OptOutLink>}
            </SpeedBumpContent>
          </SpeedBumpContainer>
        }
      </div>
    )
}

export default SpeedBump
